// storeHelpers.js

// Incrementar el número de citas
export function incrementarCitas(store) {
    store.commit('SET_NUMERO_CITAS', store.state.numeroCitas + 1);
}

// Decrementar el número de citas
export function decrementarCitas(store) {
    if (store.state.numeroCitas > 0) {
        store.commit('SET_NUMERO_CITAS', store.state.numeroCitas - 1);
    }
}

// Incrementar el número de atenciones
export function incrementarAtenciones(store) {
    store.commit('SET_NUMERO_ATENCIONES', store.state.numeroAtenciones + 1);
}

// Decrementar el número de atenciones
export function decrementarAtenciones(store) {
    if (store.state.numeroAtenciones > 0) {
        store.commit('SET_NUMERO_ATENCIONES', store.state.numeroAtenciones - 1);
    }
}

// Incrementar el número de interconsultas
export function incrementarInterconsultas(store) {
    store.commit('SET_NUMERO_INTERCONSULTAS', store.state.numeroInterconsultas + 1);
}

// Decrementar el número de interconsultas
export function decrementarInterconsultas(store) {
    if (store.state.numeroInterconsultas > 0) {
        store.commit('SET_NUMERO_INTERCONSULTAS', store.state.numeroInterconsultas - 1);
    }
}

// Incrementar el número de referencias
export function incrementarReferencias(store) {
    store.commit('SET_NUMERO_REFERENCIAS', store.state.numeroReferencias + 1);
}

// Decrementar el número de referencias
export function decrementarReferencias(store) {
    if (store.state.numeroReferencias > 0) {
        store.commit('SET_NUMERO_REFERENCIAS', store.state.numeroReferencias - 1);
    }
}
